<!--
  @Description: 我的关注-公司-没有数据
  @Author: wang.y 
  @Date: 2022-02-25 
-->
<template>
  <div class="nodata">
    <div class="default-container">
      <img :src="$store.state.static_img_url + 'pic/quesheng-2.png'">
      <p>暂无关注<br />以下是为您推荐的值得关注的公司<br />如已关注，请<a @click="$parent.getSubscribeList()">刷新看看</a>
      </p>
    </div>
    <div class="default-atten">
      <div class="group-list">
        <div :class="{'on': active_group == 'vb'}" @click="handleClickGroup('vb')" >VB数字医疗榜</div>
        <div :class="{'on': active_group == item.id}" v-for="item in yz_group" :key="item.id" @click="handleClickGroup(item.id)">{{item.name}}</div>
      </div>
      <div class="recommend-list">
        <entity-temp :position="3" v-for="item,index in reco_list" :key="index" :item="item" :entitytype="0"></entity-temp>
      </div>
    </div>
  </div>
</template>
<script>
import EntityTemp from './EntityTemp'
import { getMeta, findEntity } from '@/service'
export default {
  components: {
    EntityTemp
  },
  created() {
    this.getMeta()
  },
  mounted() { },
  data() {
    return {
      getcollection: [],
      active_group: 'vb',
      reco_list: [],
      reco_arr: []
    }
  },
  computed: {
    yz_group() {
      return this.$store.state.yz_group.filter(item => item.id !== 'yz_gorup_1')
    }
  },
  methods: {
    async getMeta() {
      let res = await getMeta({
        name: ['getcollection']
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        res.meta.getcollection.forEach(item => {
          this.getcollection.push(item.content_id)
        })
        this.handleClickGroup('vb')
      } else {
        this.$Message.error(res.message)
      }
    },
    handleClickGroup(name) {
      this.active_group = name
      let arr = []
      if(name == 'vb') {
        arr = this.getcollection
      } else {
        let index = this.yz_group.findIndex(a => a.id == name)
        if(index > -1) {
          arr = this.yz_group[index]['comp']
        }
      }
      console.log(arr)
      this.getRecoList(0, arr)
    },
    async getRecoList(tpye, arr) {
      let res = await findEntity({type: tpye, ids: arr, keyword: ''}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'reco_list', res.res)
      } else {
        console.log(res)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>      
</style>